import React, { useState } from "react";

import Profil from "./components/app/profil/profil";
import MainNav from "./components/app/mainnav";

import * as firebase from "firebase/app";
import "firebase/auth";
import Header from "./components/app/header";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import Chat from "./components/app/match/chat";
import {
  useCollectionData,
  useDocumentData,
} from "react-firebase-hooks/firestore";
import HomeApp from "./components/app/homeApp";

import Search from "./components/app/search";

const App = (props) => {
  const [searchGame, setSearchGame] = useState();

  const [mainNavToggle, setMainNavToggle] = useState(false);

  const [valueUserInfo] = useDocumentData(
    firebase.firestore().doc(`users/${props.userId}`)
  );

  const [gamesList] = useCollectionData(
    firebase.firestore().collection("gamesList")
  );

  const history = useHistory();

  firebase.auth().onAuthStateChanged(function (user) {
    if (!user) {
      // User is not signed in.
      history.push("");
    }
  });

  return (
    <>
      <Header
        userId={props.userId}
        pseudo={valueUserInfo && valueUserInfo.pseudo}
        mainNavToggle={mainNavToggle}
        setMainNavToggle={setMainNavToggle}
      />
      <MainNav
        mainNavToggle={mainNavToggle}
        setMainNavToggle={setMainNavToggle}
        userMates={valueUserInfo && valueUserInfo.mates}
        userId={props.userId}
      />
      <main className={`mainApp ${mainNavToggle ? "mainApp--navOpen" : ""} `}>
        <div>
          <Switch>
            <Route path="/app/chat/:id">
              <Chat
                userName={valueUserInfo && valueUserInfo.pseudo}
                userId={props.userId}
              />
            </Route>
            <Route path="/app/profil/:id">
              <Profil userId={props.userId} />
            </Route>
            {searchGame && (
              <Route path="/app/search">
                <Search
                  userId={props.userId}
                  valueUserInfo={valueUserInfo}
                  searchGame={searchGame}
                  gamesList={gamesList}
                />
              </Route>
            )}

            <Route path="/app">
              <HomeApp setSearchGame={setSearchGame} gamesList={gamesList} />
            </Route>
          </Switch>
        </div>
      </main>
    </>
  );
};

export default App;
